import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Smartphone, X } from "lucide-react";

const KEY = "pins:install-nudge-dismissed";

const isMobile = () => /iPhone|iPad|iPod|Android|Mobile/i.test(navigator.userAgent);
const isInstalled = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches || window.navigator.standalone === true;

/** One-time slide-up nudge for mobile browser visitors: install Pins from /install. */
export const InstallNudge = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (localStorage.getItem(KEY) === "1") return;
    if (!isMobile() || isInstalled() || pathname === "/install") return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, [pathname]);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-nudge"
      className="fixed bottom-4 left-4 right-4 z-[1400] bg-[#2c4a3e] text-[#f7f5f0] border border-[#1f1f1f] shadow-[4px_4px_0_#1f1f1f] p-3.5 flex items-center gap-3 animate-in slide-in-from-bottom-4 fade-in duration-500"
    >
      <Smartphone className="w-4 h-4 shrink-0 text-[#e0b79a]" strokeWidth={1.75} />
      <p className="text-sm leading-snug min-w-0">
        Add Pins to your home screen — journal from anywhere, even offline.{" "}
        <Link
          to="/install"
          onClick={dismiss}
          data-testid="install-nudge-link"
          className="underline underline-offset-4 decoration-[#e0b79a] font-medium whitespace-nowrap"
        >
          Show me how
        </Link>
      </p>
      <button
        type="button"
        aria-label="Dismiss install prompt"
        data-testid="install-nudge-dismiss"
        onClick={dismiss}
        className="ml-auto shrink-0 text-[#9fb3a7] hover:text-[#f7f5f0]"
      >
        <X className="w-4 h-4" strokeWidth={2} />
      </button>
    </div>
  );
};

export default InstallNudge;
